@use '@design/design-tokens/typography/typography' as *;
@use '@design/components/custom-scroll/custom-scroll' as *;

@mixin scroll-fade($direction) {
  background: linear-gradient(
    $direction,
    rgba(var(--background-soft-rgb), 0) 0%,
    rgba(var(--background-soft-rgb), 0.85) 55%,
    rgba(var(--background-soft-rgb), 1) 100%
  );
}

.wrapper {
  position: relative;
  width: 100%;
  flex-grow: 1;
  margin-bottom: 16px;
}

.chipsContainer {
  padding: 16px 0 0;
  display: flex;
  gap: 8px;
  overflow-x: auto;
  width: 100%;
  border-bottom: 1px solid var(--border-default);
  @include custom-scroll-minimal;

  &::-webkit-scrollbar {
    display: none;
  }

  scrollbar-width: none;

  &.secondary {
    padding: 16px 16px 0;
    gap: 16px;
  }
}

.styledButton {
  position: absolute;
  top: 16px;
  z-index: 1;
  height: 32px;
  width: 48px;
  border: none;
  pointer-events: auto;

  &.prev {
    left: 0;
    justify-content: flex-start;
    padding-left: 4px;
    @include scroll-fade(to left);
  }

  &.next {
    right: 0;
    justify-content: flex-end;
    padding-right: 4px;
    @include scroll-fade(to right);
  }

  &.prev:hover {
    @include scroll-fade(to left);
  }

  &.next:hover {
    @include scroll-fade(to right);
  }
}

.tabButton {
  @include typography-v2-body-sm;
  color: var(--text-default);
  padding: 5px 11px;
  cursor: pointer;
  width: fit-content;
  white-space: nowrap;
  flex-shrink: 0;

  &.secondary {
    padding: 8px 15px;
  }

  &.active {
    color: var(--text-primary);
    border-bottom: 2px solid var(--border-primary);
  }
}
